import config from 'config';
import find from 'lodash/find';
import uniqBy from 'lodash/uniqBy';

export function getStatusMapping(statusCode, mappings) {
    mappings = mappings || config.seatTypes.seatMappings;
    return find(mappings, mapping => {
        return mapping.statusCode == statusCode;
    }) || config.seatTypes.defaultMapping;
}

export function getAvailableSeatTypes() {
    return uniqBy(config.seatTypes.defaultTypes.concat(
        config.seatTypes.customTypes
    ));
}

export function getSeatType(statusCode) {
    let availableTypes = getAvailableSeatTypes();
    let mapping = getStatusMapping(statusCode);
    return find(availableTypes, type => type.id === mapping.draw);
}

export default {
    getStatusMapping,
    getAvailableSeatTypes,
    getSeatType
}



// WEBPACK FOOTER //
// ./src/javascripts/app/lib/seats/seatTypes.js